
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15.547 11.272"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.434 3.478a3.925 3.925 0 00-7.733.947v.056h-.055a3.147 3.147 0 000 6.293h7.901a3.647 3.647 0 00-.114-7.291z","fill":"none","stroke":"#6b7786","stroke-miterlimit":"10"}})])
          )
        }
      }
    